import React from 'react';
import TokenExpiryModal from './TokenExpiryModal';
import { useOktaAuth } from '@okta/okta-react';

const TokenExpiry = (props: { isPageWithoutNav: boolean }) => {
    const { authState } = useOktaAuth();

    if (authState?.isAuthenticated) {
        return <TokenExpiryModal />;
    }
    return null;
};

export default TokenExpiry;
